<template>
  <ResourceAction
    ref="resource"
    :action="action"
    :params="params"
    :debounce="debounce"
    @error="$emit('error', $event.error)"
    @success="onSuccess"
    @update:isLoading="onLoadingUpdate"
    v-slot="{ isLoading, error }"
  >
    <slot
      :isLoading="isLoading"
      :loadingPage="pagination.loadingPage"
      :error="error"
    />
  </ResourceAction>
</template>

<script>
  import { modelValueConfig } from 'src/utils/vue.js';

  import ResourceAction from 'src/components/ResourceAction/ResourceAction.vue';

  export default {
    name: 'PaginatedResource',
    components: { ResourceAction },
    model: modelValueConfig(),
    props: {
      modelValue: Object,
      action: {
        type: Function,
        required: true,
      },
      params: Object,
      debounce: Number,
      idKey: String,
    },
    provide() {
      return {
        pagination: this.pagination,
      }
    },
    data() {
      const ctx = this;
      const {
        loadAndReplaceImmediate,
        loadAndReplace,
        loadAndAppend,
        replacePrevPage,
        replaceNextPage,
        appendNextPage
      } = ctx;
      return {
        pagination: {
          get data() { return ctx.modelValue },
          get params() { return ctx.params; },
          loadAndReplaceImmediate,
          loadAndReplace,
          loadAndAppend,
          replacePrevPage,
          replaceNextPage,
          appendNextPage,
          get hasNextPage() {
            const { modelValue } = ctx;
            if (!modelValue) return false;
            const { currentPage, totalPages } = modelValue.meta;
            return currentPage !== totalPages;
          },
          loadingPage: null,
        },
      }
    },
    methods: {
      loadAndReplaceImmediate(params) {
        this.$refs.resource.dispatch(params, { immediate: true, strategy: 'replace' });
      },
      loadAndReplace(params) {
        this.$refs.resource.dispatch(params, { strategy: 'replace' });
      },
      loadAndAppend(params) {
        this.$refs.resource.dispatch(params, { immediate: true, strategy: 'append' });
      },
      replacePrevPage() {
        this.loadAndReplace({ page: this.modelValue.meta.currentPage - 1 });
      },
      replaceNextPage() {
        this.loadAndReplace({ page: this.modelValue.meta.currentPage + 1 });
      },
      appendNextPage() {
        this.loadAndAppend({ page: this.modelValue.meta.currentPage + 1 });
      },
      onSuccess({ data, params, config, context: { strategy } }) {
        const value = { ...data };
        if (strategy === 'append') {
          if (value.meta.currentPage !== 1) {
            if (this.idKey) {
              const { idKey } = this;
              const keys = this.modelValue.list.map(item => item[idKey]);
              const filtered = value.list.filter(item => !keys.includes(item[idKey]));
              value.list = [...this.modelValue.list, ...filtered];
            } else {
              value.list = [...this.modelValue.list, ...value.list];
            }
          }
        }
        this.$emit('update:modelValue', value);
        this.$emit('success', { data, params, config });
      },
      cancel() {
        this.$refs.resource.cancel();
      },
      onLoadingUpdate({ value, params }) {
        if (value) {
          this.pagination.loadingPage = params.page || 1;
        } else {
          this.pagination.loadingPage = null;
        }
        this.$emit('loading-state-change', { value, params });
      },
    },
  }
</script>